// @flow
import React, { type Node } from 'react';
import lightBulbIconSrc from '../../icons/light-bulb-icon.svg';
import { InformationBox } from '../../../../../organisms/information-box';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { Empty } from '@tectonics/look-and-feel/volcanes/atoms';
import { translate } from '@tectonics/translate';

export function ColombianExternalPayProviderInfo(): Node {
  const [selectedExternalPayProvider] = useUserInputValue('selectedExternalPayProvider');

  switch(selectedExternalPayProvider) {
    case 'achpse':
      return <AchPseInstructions />;
    case 'bancolombia-button':
      return <BancolombiaButtonInstructions />;
    default:
      return <Empty />;
  }
}

function AchPseInstructions(): Node {
  return(
    <InformationBox icon={lightBulbIconSrc} iconAlt="info icon" fillBackground={true}>
      {translate('volcanes.payment-methods.externalpayprovider.paymentMethodInfo.achpse')}
    </InformationBox>
  );
}

function BancolombiaButtonInstructions(): Node {
  return (
    <InformationBox icon={lightBulbIconSrc} iconAlt="info icon" fillBackground={true}>
      {translate('volcanes.payment-methods.externalpayprovider.paymentMethodInfo.bancolombia')}
    </InformationBox>
  );
}
